
(() => {
  const selector = '.gvip-card-video';
  const seen = new WeakSet();

  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver(entries => {
        entries.forEach(({ target, isIntersecting }) => {
          if (isIntersecting && !document.hidden) {
            target.play().catch(() => {});
          } else {
            target.pause();
          }
        });
      }, { threshold: 0.25 })
    : null;

  function init() {
    document.querySelectorAll(selector).forEach(video => {
      if (seen.has(video)) return;
      seen.add(video);

      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.playsInline = true;

      if (observer) {
        observer.observe(video);
      } else {
        video.play().catch(() => {});
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  new MutationObserver(init).observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  document.addEventListener('visibilitychange', () => {
    document.querySelectorAll(selector).forEach(video => {
      if (document.hidden) video.pause();
    });
  });
})();
